module.exports = __webpack_public_path__ + "img/bioshock (8).17ee84a2.jpg";